
<div class="autowcont allpads m-top-ii">
  <div class="basicrow f-reg f-black roboto-r">
    <div class="basicrow f-big">
      Recargar
    </div>
    <div class="dts-rcrg m-top-ii text-center">
      <div class="left-number">
        <div class="basicrow">
          <span class="roboto-b">N&uacute;mero de T&eacute;lefono</span><br />
          <span class="f-big roboto-b">{{this.subscriber}}</span>
        </div>
      </div>
      <div class="right-number">
        <div class="basicrow l-pline-i">
          <span class="roboto-b">Balance en Prepago Disponible</span><br />
          <span class="f-lsemi roboto-b f-red">{{this.prepaidBalance | currency}}</span>
        </div>
      </div>
    </div>
    <div class="basicrow m-top-i">
      <div class="logline full"></div>
    </div>
    <div>
      <div class="basicrow m-top-i">
        <div class="basicrow roboto-b f-bmed text-center">
          Monto seg&uacute;n Plan Actual
        </div>
        <div class="basicrow text-center">
          <div class="mnts-rcrg" id="option_a" style="border: 0px solid #dddddd;">
            {{this.realAmountPlan|currency}}
          </div>
        </div>
      </div>
      <div class="basicrow m-top-i" ng-if="this.list.length > 0">
        <div class="logline full"></div>
      </div>
      <div class="basicrow m-top-i" ng-if="this.list.length > 0">
        <div class="basicrow roboto-b f-bmed text-center">
          Otras Recargas Disponibles
        </div>
        <div class="basicrow text-center">
          <div class="list-recharges" *ngFor="let list of this.list; let i = index">
            <div class="mnts-rcrg rcrg-a" *ngIf="list.idProduct!=24" id="option_{{i}}" (click)="this.option(i,0,list.amountRecharge,list.idProduct,list.ivuState);this.otherMount=false;">
              <div class="checkrcrg checkrcrg-b">
                <input type="radio" name="radioG2" id="check_{{i}}" class="css-radio" style="display: none;"><label for="radioG2" class="css-label3 radGroup1"></label>
              </div>
              {{list.productName}}
            </div>
          </div>
        </div>
        <div class="basicrow text-center" *ngFor="let list of this.list; let i = index">
          <div class="list-recharges" *ngIf="list.idProduct==24" (click)="this.option(i,2,list.amountRecharge,list.idProduct,list.ivuState)">
            <div class="othr-mnts-rcrg">
              <div class="mnts-othr-2 vcenter" id="option_b">
                <div class="checkrcrg checkrcrg-c ">
                  <input type="radio" name="radioG2" id="check_b" class="css-radio" style="display: none;"><label for="radioG2" class="css-label3 radGroup1"></label>
                </div>
                <div class="tabcell" (click)="this.otherMount=true">
                  Otro Monto
                </div>
              </div>
              <input class="mnts-inpr" [appOnlyAmount] [(ngModel)]="this.valueRecharge2">
            </div>
          </div>
        </div>
      </div>
      <div class="basicrow m-top-i" ng-if="this.list.length > 0">
        <div class="logline full"></div>
      </div>
      <div class="basicrow m-top-i m-bott-ii" ng-if="this.list.length > 0">
        <a class="btns red def-i pull-right vcenter" (click)="this.continuePrepaidRecharge()">
                    <span class="tabcell">
                        Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
        </a>
      </div>
    </div>
  </div>
</div>
